<template>
  <div style='min-height: calc(100vh - 176px);'
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
    <div v-for="(obj, index) in extraComponents" :key="index + labels.length"
      class="inl-21 mb-5 mr-2 last:mr-0 flex flex-wrap text-center">
      <component v-if="index === componentIndex" :is="comp" 
        :componentIndex="componentIndex" :pageId="pageId"
        :title="obj.title"
        :closeCoponentModal="closeCoponentModal" :baseUrl="obj.baseUrl"></component>
    </div>

    <div class="rounded-t bg-white mb-0 px-6 py-6">

      <ul style='text-align: center' class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
        <li v-for="(item, index) in labels" :key="index + 1"
          class="inl-21 mb-5 mr-2 last:mr-0 flex flex-wrap text-center">
          <router-link class="w-full max-w-md text-xs font-bold uppercase shadow-lg rounded block leading-normal" :class="[
          ]" :to="{
              path: item.action != 'base' ?
                `${mainPath}${pageId}/${item.action}`
                : `${mainPath}${pageId}`
            }" v-slot="{ href, navigate, isActive }">
            <a :class="[
              !isActive ? 'text-emerald-600 bg-white' : '',
              isActive && item.action === currentAction ? 'text-white bg-emerald-600' : '',
              'w-full leading-normal px-5 py-3 rounded block leading-normal'
            ]" :href="href" @click="navigate">
              {{ item.name }}
            </a>
          </router-link>
        </li>
        <li v-for="(obj, index) in extraComponents" :key="index + labels.length"
          class="inl-21 mb-5 mr-2 last:mr-0 flex flex-wrap text-center">
          <div @click="openComponent(index)"
            class="w-full max-w-md text-xs font-bold uppercase shadow-lg rounded block leading-normal">
            <a class='text-emerald-600 bg-white w-full leading-normal px-5 py-3 rounded block leading-normal '>
              {{ obj.title }}
            </a>
          </div>
        </li>
      </ul>

      <button v-if="addLibrary" style='position: absolute; right: 25px; top: 18px;'
        class="inl-20 bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
        type="button">
        Электронная библиотека
      </button>

    </div>
    <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
      <form :on-submit="updateData">
        <h6 class="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
          {{ getLabel() }}
        </h6>
        <div class="flex flex-wrap">
          <div v-for="(elem, index) in formField" :key="index" class="w-full lg:w-6/12 px-4">
            <div v-for="(field, in_index) in elem" :key="in_index" class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                {{ field.label }} <br>
              </label>
              <div v-if="field.type == 'str'">
                <input type="text"
                  class="h-10 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  :value="formValData[field.field_name]"
                  @input="event => formValData[field.field_name] = event.target.value" />
              </div>
              <div v-else-if="field.type == 'html'">
                <QuillEditor
                  :content="formValData[field.field_name]"
                  @update:content="(val) => formValData[field.field_name] = val"
                  content-type="html"
                  theme="snow"
                  class="bg-white"
                />
              </div>
              <div v-else-if="field.type == 'text'">
                <textarea
                  :style="{
                    mninHeight: '100px',
                  }"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  :value="formValData[field.field_name]"
                  @input="event => formValData[field.field_name] = event.target.value"
                  rows="6">
                </textarea>
              </div>
              <div v-else-if="field.type == 'choice'">
                <model-select :options="getSelectOptions(field.vals)" v-model="formValData[field.field_name]"
                  :placeholder="field.help_text || field.label">
                </model-select>
              </div>
              <div v-else-if="field.type == 'fk'">
                <model-select :options="getSelectOptions(field.vals)" v-model="formValData[field.field_name]"
                  :placeholder="field.help_text || field.label">
                </model-select>
              </div>
              <div v-else-if="field.type == 'image'">
                <ImageField v-model="formValData[field.field_name]" />
              </div>
              <div v-else-if="field.type == 'file'">
                <FileField v-model="formValData[field.field_name]" />
              </div>
              <div v-else-if="field.type == 'bool'">
                <input 
                  v-model="formValData[field.field_name]"
                  type="checkbox" name="" id="">
              </div>
              <div v-else-if="field.type == 'int'">
                <input type="text"
                  class="h-10 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  :value="formValData[field.field_name]"
                  @input="event => formValData[field.field_name] = event.target.value" />
              </div>
              <div class="relative inl-40" v-else-if="field.type == 'datetime' || field.type == 'date'">
                <div>
                  {{ formValData[field.field_name] }} <br>
                </div>
                <Datepicker v-model="formValData[field.field_name]" locale='ru' :month-change-on-scroll="false"
                  :enable-time-picker="field.type == 'datetime'" :format="dateTimeFormatPicker(field.type == 'datetime')"
                  select-text="Выбрать"
                  cancel-text="Закрыть">
                  <input type="text" readonly='readonly'
                    class="inl-32 h-10 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring ease-linear transition-all duration-150"
                    :value="formValData[field.field_name]" />
                </Datepicker>
              </div>
            </div>
          </div>

          <div class='text-center w-full mt-4 flex gap-4 justify-center'>
            <button
              class="mt-4 mr-4 bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
              type="submit" v-on:click='updateData' @click.stop.prevent>
              <span v-if="!formSend">
                <span v-if="isCreate">Создать</span>
                <span v-else>Cохранить</span>
              </span>
              <span v-else>Дождитесь ответа</span>
            </button>
            <button
              v-if="backRoute"
              type="button"
              @click="$router.push(backRoute)"
              class="mt-4 bg-gray-500 text-white hover:bg-gray-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
            >
              Назад
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>

import axios from 'axios';
import { HEADERS_TOKEN } from '@/const/uri';
import ImageField from '@/components/Forms/ImageField';
import FileField from '@/components/Forms/FileField';
import VueDatePicker from '@vuepic/vue-datepicker';
import { mapMutations, mapActions } from 'vuex';
import { ModelSelect } from 'vue-search-select';
import { dateTimeFormatPicker, getSelectOptions } from '@/utils/base.js';
import { defineAsyncComponent } from "vue";
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';

export default {
  components: {
    Datepicker: VueDatePicker,
    ModelSelect, ImageField,
    FileField,
    QuillEditor,
  },
  mounted() {
    this.currentAction = this.$route.params.slug || 'base';
    this.pageId = this.$route.params.id;
    let links = this.$route.path.split('/');
    this.mainPath = links.slice(0, 3).join('/') + '/';
    this.loadDdata();
  },
  watch: {
    $route(to) {
      this.currentAction = to.params.slug || 'base';
      this.loadDdata();
    }
  },
  computed: {
    comp() {
      if (this.componentIndex === null) return null;
      if (this.componentIndex > this.$props.extraComponents.length - 1) return null;
      return defineAsyncComponent(() => {
        return import(`@/components/${this.$props.extraComponents[this.componentIndex].component}`);
      });
    },
  },
  data() {
    return {
      componentIndex: null,
      openTab: 1,
      formValData: {},
      allCodes: {},
      pageId: null,
      mainPath: '',
      labels: [],
      formField: {},
      mainForm: null,
      formData: {},
      currentAction: 'base',
      formSend: false,
    };
  },
  methods: {
    getSelectOptions,
    dateTimeFormatPicker,
    ...mapActions(['toggleAlert']),
    ...mapMutations(['modalShow', 'modalClose', 'createUser',]),
    getLabel() {
      let method = '';
      this.labels.forEach(element => {
        if (element.action == this.currentAction) method = element.name;
      });
      return method;
    },
    openComponent(index) {
      this.componentIndex = index;
    },
    closeCoponentModal() {
      this.componentIndex = null;
    },
    toggleTabs: function (tabNumber) {
      this.currentAction = tabNumber;
      this.loadDdata();
    },
    serializeFormData(formData) {
      let data = [],
        inData = [];
      formData.forEach((element, index) => {
        inData.push(element);
        if (index % 2 != 0) {
          data.push(inData);
          inData = [];
        }
      });
      if (inData) {
        data.push(inData);
      }
      return data;
    },
    formatDate(date, format) {
      if (!date || !(date instanceof Date)) {
        console.warn('Invalid date passed to formatDate:', date);
        return '';
      }
      console.log('formatDate', date, typeof date, format);
      if (format == 'date') {
        return date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear();
      }
      if (format == 'datetime') {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const result = `${day}.${month}.${year} ${hours}:${minutes}`;
        console.log(result);
        return result;
      }
    },
    setFormData(dataForm, dataResult) {
      dataForm.forEach(element => {
        if (dataResult[element.field_name]) {
          if (element.type == 'choice') {
            this.formValData[element.field_name] = dataResult[element.field_name].key;
          }
          else if (element.type == 'fk') {
            this.formValData[element.field_name] = dataResult[element.field_name + '_id'];
          }
          else {
            this.formValData[element.field_name] = dataResult[element.field_name];
          }
        } else {
          this.formValData[element.field_name] = null;
        }
      });
    },
    getUrl(add) {
      if (this.isCreate) {
        if (!add) {
          return this.actions['base'] + `forms/`
        } else {
          return this.actions['base'];
        }
      }
      if (this.currentAction == 'base') {
        return this.actions[this.currentAction] + `${this.pageId}/`;
      }
      return `${this.actions.base}${this.pageId}/${this.currentAction}/`
    },
    getFormdata() {
      const formData = new FormData();
      const objdata = {};
      this.mainForm.forEach(obj => {
        const field_name = obj.field_name;
        const type = obj.type;
        const val = this.formValData[field_name];
        if (type == 'datetime' || type == 'date') {
          console.log('type:', type, 'val:', val);
          if (typeof val == 'string') {
            objdata[field_name] = val;
          } else {
            objdata[field_name] = this.formatDate(val, type,);
          }
        }
        else if (type == 'fk') {
          if (val) {
            objdata[field_name] = parseInt(val);
          } else {
            objdata[field_name] = Object.keys(obj.vals)[0];
          }
        }
        else if (type == 'bool') {
          if (val == null) {
            objdata[field_name] = false;
          } else {
            objdata[field_name] = val;
          }
        }
        else if (type == 'image') {
          if (typeof val != 'string' && val)
            formData.append(field_name, val);
        }
        else if (type == 'file') {
          if (typeof val != 'string' && val)
            formData.append(field_name, val);
        }
        else {
          objdata[field_name] = val;
        }
      });
      formData.append('form', JSON.stringify(objdata));
      return formData;
    },
    getLabelEror(field_name) {
      let label = ''
      this.mainForm.forEach(element => {
        if (element.field_name == field_name) {
          label = element.label;
          return;
        }
      });
      return label;
    },
    showErros(errors) {
      let allMessages = [];
      for (const key in errors) {
        var messages = typeof errors[key] == 'string' ? errors[key] : errors[key].join(', ');
        allMessages.push({
          'title': this.getLabelEror(key),
          'message': messages,
        });
      }
      this.modalShow({
        messages: allMessages,
        title: 'Проверьте данные формы',
        isError: true,
      });
    },
    async updateData() {
      this.formSend = true;
      const formData = this.getFormdata();
      const url = this.getUrl(true);
      await axios({
        method: this.isCreate ? "POST" : "PUT",
        url: url,
        data: formData,
        headers: HEADERS_TOKEN(),
      }).then((e) => {
        this.formSend = false;
        this.toggleAlert({
          message: e.data.data.message,
          isError: false,
        });
        if (e.data.data.update_user) {
          this.createUser(e.data.data.result);
        }
        if (this.isCreate) {
          let id = e.data.data.result.id;
          this.$router.push({
            name: this.redPathName,
            params: { id }
          });
        }
      }).catch((e) => {
        const status = e.status;
        if ([400, 404, 403,].indexOf(status)) {
          const data = e.response.data;
          const errors = data.errors;
          this.showErros(errors);
        } else {
          this.toggleAlert({
            message: 'Ошибка сервера, обратитесь в техподдрежку',
            isError: true,
          });
        }
        this.formSend = false;
      });
    },
    logUser() { },
    async loadDdata() {
      const url = this.getUrl();
      await axios({
        method: "GET",
        url: url + "?is_create=1",
        headers: HEADERS_TOKEN(),
      }).then((e) => {
        const data = e.data.data;
        this.currentAction = data.method;
        this.labels = data.labels;
        this.mainForm = data.form;
        this.formField = this.serializeFormData(data.form);
        this.formData = data.result;
        this.setFormData(data.form, data.result);
      }).catch(function (e) {
        console.log(e);
      });
    }
 },
  props: {
    isCreate: {
      default: false,
    },
    redPathName: {
      default: '',
    },
    actions: {
      default: {},
    },
    extraComponents: {
      default: [],
    },
    addLibrary: {
      default: false,
    },
    backRoute: {
      default: null,
    }
  }

};  
</script>
